import { useEffect, useRef } from "react";

const INACTIVITY_LIMIT = 5* 60 * 1000; // 5 minutes

export const useActivityTracker = (onTimeout, isAuthenticated) => {
  const timer = useRef(null);

  const resetTimer = () => {
    if (!isAuthenticated) return; // <-- Only run if logged in
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(onTimeout, INACTIVITY_LIMIT);
  };

  useEffect(() => {
    if (!isAuthenticated) return; // <-- Don't attach listeners for guest

    const events = ["mousemove", "keydown", "scroll", "click"];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // start timer initially

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timer.current) clearTimeout(timer.current);
    };
  }, [isAuthenticated]);
};
